import { displayDate, displayFullname, displayNumberWithComma } from "~/plugins/functions/display";


// For DTO UserAssociation
export interface IModelGETUserAssociationConversationRequest {
  orderBy: string;
  orderType: string;
  search: string;
  startCreatedAt: string;
  endCreatedAt: string;
  count: boolean;
  page: number;
  limit: number;
}

export interface IModelGETUserAssociationConversationResponse {
  accessKeyId: string;
  adminConsoleId: number;
  avatar: string;
  conversationCount: string;
  createdAt: string | Date;
  deletedAt: null | Date;
  email: string;
  id: number;
  inputToken: string;
  lastActiveAt: null | string | Date;
  lastLoginAt: null
  originAppId: number;
  outputToken: string;
  password: string;
  phone: string;
  pinCode: null | string;
  presetName: string;
  secretAccessKeyId: string;
  secretExpiredAt: null | Date;
  status: string;
  updatedAt: string | Date;
  username: string;
}

export class ModelGETUserAssociationConversation {
  accessKeyId: string;
  adminConsoleId: number;
  avatar: string;
  conversationCount: string;
  createdAt: string | Date;
  deletedAt: null | string | Date;
  email: string;
  id: number;
  inputToken: string;
  lastActiveAt: null | string | Date;
  lastLoginAt: null
  originAppId: number;
  outputToken: string;
  password: string;
  phone: string;
  pinCode: null | string;
  presetName: string;
  secretAccessKeyId: string;
  secretExpiredAt: null | Date;
  status: string;
  updatedAt: string | Date;
  username: string;

  displayCreatedAt: string;
  displayAvatar: string;

  constructor(props = {} as IModelGETUserAssociationConversationResponse) {
    props = props ?? {} as IModelGETUserAssociationConversationResponse;
    this.accessKeyId = props.accessKeyId;
    this.adminConsoleId = props.adminConsoleId;
    this.avatar = props.avatar;
    this.conversationCount = props.conversationCount || '';
    this.createdAt = props.createdAt || '';
    this.deletedAt = props.deletedAt || null;
    this.email = props.email || '';
    this.id = props.id;
    this.inputToken = displayNumberWithComma(props.inputToken);
    this.lastActiveAt = props.lastActiveAt || null;
    this.lastLoginAt = props.lastLoginAt || null;
    this.originAppId = props.originAppId;
    this.outputToken = displayNumberWithComma(props.outputToken);
    this.password = props.password;
    this.phone = props.phone;
    this.pinCode = props.pinCode;
    this.presetName = props.presetName || '';
    this.secretAccessKeyId = props.secretAccessKeyId || '';
    this.secretExpiredAt = props.secretExpiredAt || null;
    this.status = props.status || '';
    this.updatedAt = props.updatedAt || '';
    this.username = props.username || '';

    this.displayCreatedAt = displayDate(this.createdAt);
    this.displayAvatar = '';
  }
}